var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',_vm._g(_vm._b({attrs:{"error-messages":_vm.errorMessages(),"prepend-icon":"mdi-archive","append-outer-icon":_vm.File
        ? 'mdi-delete'
        : '',"loading":_vm.loading,"disabled":_vm.loading},on:{"change":_vm.readData,"click:append-outer":function($event){_vm.File
        ? _vm.$emit('setFile', null)
        : ''}}},'v-file-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }